import React from "react";
import Button from "@material-ui/core/Button";
import {
  Create,
  SimpleForm,
  TextInput,
  Toolbar,
  translate,
  SelectInput,
  PasswordInput,
} from "react-admin";

import { OperateCallback } from "../../../components/OperateCallback";

const validateCreation = (values) => {
  const errors = {};
  if (!values.nickname) {
    errors.nickname = "The nick name is required";
  }
  if (!values.email) {
    errors.email = "The E-mail is required";
  }
  if (!values.password) {
    errors.password = "The password is required";
  }
  if (!values.active_status && values.active_status !== 0) {
    errors.active_status = "The active status is required";
  }
  return errors;
};

const CreateToolbar = translate(({ onCancel, translate, ...props }) => {
  return (
    <Toolbar {...props}>
      <OperateCallback props={props} operate="create" />
      <Button onClick={onCancel}>{translate("ra.action.cancel")}</Button>
    </Toolbar>
  );
});

const SystemUserCreate = ({ onCancel, ...props }) => (
  <Create title=" " {...props}>
    <SimpleForm
      validate={validateCreation}
      toolbar={<CreateToolbar onCancel={onCancel} />}
    >
      <TextInput source="nickname" label="ra.sources.nickname" />
      <TextInput source="email" label="ra.sources.email" />
      <PasswordInput source="password" label="ra.sources.password" />
      <SelectInput
        source="active_status"
        label="ra.sources.status"
        choices={[
          { id: 1, name: "ra.sources.enable" },
          { id: 0, name: "ra.sources.disable" },
        ]}
        defaultValue={1}
      />
    </SimpleForm>
  </Create>
);

export default SystemUserCreate;
